import React, { useCallback, useState } from "react";
import * as Yup from "yup";
import {
  Row,
  Col,
  FormGroup,
  Label,
} from "reactstrap";
import Title from "../../title";
import { Field } from "formik";
import { cashesList, customStyle } from "../../appointment/utils";
import ReactSelect from "react-select";
import { useSelector } from "react-redux";
import { useEffect } from "react";
import { getStaffsList } from "../../../views/pages/gymPortion/reports/utils";

export const FormFirstStep = (formikProps) => {
  const { errors, touched, values, setFieldValue } = formikProps;
  const [staffsList, setStaffsList] = useState([]);

  const _getStaffsList = async () => {
    const staffs = await getStaffsList();
    setStaffsList(staffs);
  };

  useEffect(() => {
    _getStaffsList();
  }, []);

  return (
    <div className="">
      <div className="basic-info">
        <div className="members-info-wrapper info-wrapper border-bottom-1 blk-padding-y">
          {/* <div className="info-title">
            <Title title="Start Staff Session Info"/>
          </div> */}
          <div className="info">
            <Row>
            <Col md={6}>
              <FormGroup className="custom-inputs">
                <Field
                  type="number"
                  name="endCashOnSite"
                  id="endCashOnSite"
                  min={0}
                  placeholder={"Cash On Site"}
                  className={`form-control ${errors.endCashOnSite &&
                    touched.endCashOnSite &&
                    "is-invalid"}`}
                />
                {errors.endCashOnSite && touched.endCashOnSite ? (
                  <div className="invalid-feedback">{`${errors.endCashOnSite}`}</div>
                ) : null}
                <Label for="endCashOnSite">
                  Cash On Site
                </Label>
              </FormGroup>
            </Col>
            <Col md={6}>
                <FormGroup className="custom-inputs">
                  {
                    staffsList && staffsList.length > 0 ?
                    <ReactSelect
                      name="assignedStaffToConfirm"
                      options={staffsList}
                      className={`form-control custom-inputs p-0 h-100 d-flex align-items-center mb-0 ${errors.assignedStaffToConfirm &&
                        touched.assignedStaffToConfirm &&
                        "is-invalid"}`}
                      styles={customStyle}
                      onChange={(user) => setFieldValue("assignedStaffToConfirm", user.value)}
                    />
                    :
                    <Field
                      type="text"
                      disabled={true}
                      value={"Loading..."}
                      className={`form-control`}
                    />
                  }
                  {errors.assignedStaffToConfirm && touched.assignedStaffToConfirm ? (
                    <div className="invalid-feedback">{`${errors.assignedStaffToConfirm}`}</div>
                  ) : null}
                  <Label for="assignedStaffToConfirm">
                    Assign Staff To Confirm
                  </Label>
                </FormGroup>
              </Col>
            </Row>
          </div>
        </div>
      </div>
    </div>
  );
};
